angular.module('aprima-legacy-common').factory('XamarinWebViewManager',
    ['RouteFormatter', '_', 'Bridge', '$state',
        function (RouteFormatter, _, Bridge, $state) {
            'use strict';

            function completeRoute(appState){
                var parentSeperator = appState.state.lastIndexOf('.');
                
                if(parentSeperator > 0){
                    var parentState = $state.get(appState.state.substring(0, parentSeperator));
                    
                    return completeRoute({state: parentState.name, route: parentState.url}) + appState.route;
                }
                else{
                    return appState.route;
                }
            }

            function getRoute(appRoute, transition) {
                if (!appRoute.route) {
                    return '';
                }

                var completedRoute = completeRoute(appRoute);
                return RouteFormatter.formatRelativeRoute(completedRoute, $state.get('^').url, transition.opts);
            }

            function activateView(appRoute, transition) {
                var route = getRoute(appRoute, transition);

                Bridge.navigate(appRoute, route, transition);

                return true;
            }
            
            Bridge.onNavigate(function (d) {
                if (!_.isUndefined(d)) {
                    var opts = JSON.parse(d.opts);

                    if(opts && opts.replaceCurrentState === true){
                        $state.go(d.state, opts, {location: 'replace'});
                    }
                    else{
                        $state.go(d.state, opts);
                    }
                }
            });

            function goBack(){
                Bridge.goBack();
            }

            return {
                activateView: activateView,
                goBack : goBack
            };
        }]);
